import React, { useContext, useEffect, useState } from 'react';
import Breadcrumb from '../../Breadcrumb/Breadcrumb';
import { UserContext } from '../../../UserContext';
import axios from '../../../axios';
import { checkPermiso } from '../../../Utils/PermissionsFunctions';
import Loader from '../../../Layout/Loaders/Loader';
import { BlobProvider } from '@react-pdf/renderer';
import ReporteGlobalPDFPorDíaEnSucursal from '../PDFs/ReporteGlobalPDFPorDíaEnSucursal';

const today = new Date(new Date(new Date().setHours(0, 0, 0, 0)).toString().split('GMT')[0] + ' UTC').toISOString();
const todayEnd = new Date(new Date(new Date().setHours(23, 59, 59, 999)).toString().split('GMT')[0] + ' UTC').toISOString();

const ReporteXDiaSucursal = () => {
    const {user} = useContext(UserContext);
    const [dia,setDia] = useState(new Date());
    const [rango,setRango] = useState({field:'fecha_pedido',start:today,end:todayEnd});
    const [ordenes,setOrdenes] = useState([]);
    const [sucursales,setSucursales] = useState([]);
    const [loader,setLoader] = useState(true);
    const [permisos,setPermisos] = useState({
        orders_read:null,
    });

    useEffect(()=>{
        _getSucursales();
        if(user.id){
            console.log("USer",user);
            setPermisos((prevPremisos) => ({
                ...prevPremisos,
                orders_read:checkPermiso("orders_read",user.permissions)
            })); 
            setRango({...rango,sucursal_id:user.sucursal_id});
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[user]);

    useEffect(()=>{
        setLoader(true);
        const getPedidos = () =>{
            axios.post("/api/daily-sucursal-report",rango).then((resp)=>{
                console.log("respuesta",resp);
                setOrdenes(resp.data);
            }).catch(e=>console.log("Error",e))
        }

        if(permisos.orders_read) getPedidos();
    },[permisos, rango]);

    useEffect(()=>{
        if(ordenes.length>0) setLoader(false);
    },[ordenes])

    const _getSucursales = () =>{
        axios.get('api/sucursals').then((resp)=>{
            setSucursales(resp.data)
        }).catch(e=>console.error("Error ",e));
    }

    const handleDate = (e) => {
        let date =  new Date(e.target.value);
        date.setDate(date.getDate());
        let nextDate = new Date(e.target.value);
        nextDate.setDate(date.getDate()+1);
        //date.toLocaleString('en-US', { timeZone: 'America/Mexico_City' });
        setDia(nextDate);
        setRango({...rango,start:date,end:nextDate});
    }

    return (
        <div>
            <div className='container-admin-menu '> <Breadcrumb hasButton={true} hasFilters={false} /> </div>
            <div className='container-admin-container'>
                <div className='container-admin z-depth-1 row'>
                    <div className='row col s12 info-badge border-r-10 m-p-0 centrar-h' style={{bordeRadius:'10px!important', padding:'0px!important',}}>
                        <div className="col s12 m7 p-0">
                           <h5>Reporte Global por día en Sucursal</h5>
                           <div>Fecha Analisis: {dia.toLocaleDateString("es-MX", { year: 'numeric', month: 'long', day: 'numeric' })} </div>
                        </div>
                        <div className="row col s12 m5 input-text">
                            <div className='col s12 m4 m-p-0 centrar'>
                                {!loader &&
                                <BlobProvider document={<ReporteGlobalPDFPorDíaEnSucursal ordenes={ordenes} dia={dia} fileName="Reporte_Global_Por_Dia_En_Sucursal.pdf" />}>
                                {({url}) => (
                                    <a className="btn-blanco puntero" style={{marginTop:15}} href={url} target="_blank" rel="noreferrer">
                                        <img className='col s2 m2 m-p-0 dentometric centrar' src='/images/pdf-reporte.png' alt='reporte PDF' style={{width:'20px'}} />
                                        <span className='centrar'> &nbsp;&nbsp;Descargar PDF </span>
                                    </a>
                                )}
                                </BlobProvider>
                                }
                            </div>
                            <div className='col s12 m4'>
                                <label htmlFor="dia">Selecciona una sucursal</label>
                                <select className='browser-default' style={{maxHeight:30}} onChange={(e)=>setRango({...rango,sucursal_id:e.target.value})} value={rango.sucursal_id}>
                                    <option value="" disabled selected>Selecciona una sucursal</option>
                                    {sucursales.map((suc) =>
                                        <option value={suc.id}  key={suc.id}>{suc.nombre_sucursal}</option>
                                    )}
                                </select>

                            </div>
                            <div className='col s12 m4'>
                                <label htmlFor="dia">Seleccionar día</label>
                                <input id="dia" type="date" onChange={handleDate}/>
                            </div>
                        </div>
                    </div>
                    <div className='col m12 row m-0 p-10 z-depth-1 border-r-6'>
                        {!loader ? 
                            ordenes.map((orden,index)=>
                                <>
                                    <div className='row col s12 info-badge border-r-10 m-p-0 centrar-h' 
                                    style={{backgroundColor:'#11cdef', bordeRadius:'10px!important', padding:'0px!important',}} key={index}>
                                        <h5 className='m-p-0'>Sucursal:{orden.nombre_sucursal} </h5>
                                    </div>
                                    
                                    <div className="col m12 container p-10 table table-doc">
                                        {orden.atendidos.map((atendido,indx)=>
                                            <> 
                                                {atendido.ordenes.map((orden,i)=>
                                                    <div className='p-t-15' key={i}>
                                                        <div className='row m-p-0' 
                                                        style={{display:'flex', borderTop:'solid 1px #3c4d69', borderLeft:'solid 1px #3c4d69', borderRight:'solid 1px #3c4d69'}}>
                                                            <div className='col s12 m2' style={{border:'solid 1px #cdcdcd'}}>
                                                                <label htmlFor="dia" style={{fontSize:10, color:'blue'}}>Fecha:</label><br/>
                                                                {orden.fecha_pedido}
                                                            </div>
                                                            <div className='col s12 m3' style={{border:'solid 1px #cdcdcd'}}>
                                                                <label htmlFor="dia" style={{fontSize:10, color:'blue'}}>Doctor:</label><br/>
                                                                {orden?.doctor.nombre +" "+ orden?.doctor.apellidos }
                                                            </div>
                                                            <div className='col s12 m3' style={{border:'solid 1px #cdcdcd'}}>
                                                                <label htmlFor="dia" style={{fontSize:10, color:'blue'}}>Paciente:</label><br/>
                                                               {orden?.patient.nombre}
                                                            </div>
                                                            <div className='col s12 m2' style={{border:'solid 1px #cdcdcd'}}>
                                                                <label htmlFor="dia" style={{fontSize:10, color:'blue'}}>ID Pedido:</label><br/>
                                                                {orden.id}
                                                            </div>
                                                            <div className='col s12 m2' style={{border:'solid 1px #cdcdcd'}}>
                                                                <label htmlFor="dia" style={{fontSize:10, color:'blue'}}>Pago:</label><br/>
                                                                ${orden.order_payment.total}
                                                            </div>
                                                        </div>
                                                        <div className='row m-p-0'
                                                        style={{display:'flex', borderBottom:'solid 1px #3c4d69', borderLeft:'solid 1px #3c4d69', borderRight:'solid 1px #3c4d69'}}>
                                                            <div className='col s12 m3' style={{border:'solid 1px #cdcdcd'}}>
                                                                <label htmlFor="dia" style={{fontSize:10, color:'blue'}}>Atendido X:</label><br/>
                                                                {atendido.empleado}
                                                            </div>
                                                            <div className='col s12 m1' style={{border:'solid 1px #cdcdcd'}}>
                                                                <label htmlFor="dia" style={{fontSize:10, color:'blue'}}>Metodo:</label><br/>
                                                                {orden.order_payment.metodo_de_pago}
                                                            </div>
                                                            <div className='col s12 m1' style={{border:'solid 1px #cdcdcd'}}>
                                                                <label htmlFor="dia" style={{fontSize:10, color:'blue'}}>Importe:</label><br/>
                                                                ${orden.order_payment.total}
                                                            </div>
                                                            <div className='col s12 m1' style={{border:'solid 1px #cdcdcd'}}>
                                                                <label htmlFor="dia" style={{fontSize:10, color:'blue'}}>Anticipo:</label><br/>
                                                                ${orden.order_payment.anticipo1}
                                                                {Number (orden.order_payment.anticipo2) > 0? orden.order_payment.anticipo2: ''}
                                                                {Number (orden.order_payment.anticipo3) > 0? orden.order_payment.anticipo3: ''}
                                                            </div>
                                                            <div className='col s12 m6' style={{border:'solid 1px #cdcdcd'}}>
                                                                <label htmlFor="dia" style={{fontSize:10, color:'blue'}}>Estudios:</label>
                                                                <ul className='m-p-0'>
                                                                    {orden.order_details.map((ele)=> 
                                                                        <li key={ele.product.id}> - {ele.product.nombre_producto} </li>
                                                                    )}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                <div className=' p-t-15'  key={index}>
                                                    <div className='row m-p-0'
                                                    style={{display:'flex', background:'#cdcdcd'}}>
                                                        <div className='col s12 m3' style={{border:'solid 1px #cdcdcd'}}>
                                                            <label htmlFor="dia" style={{fontSize:10, color:'blue'}}>Pedidos Atendidos:</label><br/>
                                                            {atendido?.ordenes?.length}
                                                        </div>
                                                        <div className='col s12 m6' style={{border:'solid 1px #cdcdcd'}}>
                                                            <label htmlFor="dia" style={{fontSize:10, color:'blue'}}>Atendidos Por:</label><br/>
                                                            {atendido.empleado}
                                                        </div>
                                                        <div className='col s12 m3' style={{border:'solid 1px #cdcdcd'}}>
                                                            <label htmlFor="dia" style={{fontSize:10, color:'blue'}}>Total de Corte:</label><br/>
                                                            ${atendido.total}
                                                        </div>
                                                    </div>
                                                </div>
                                            
                                            </>
                                        )}
                                            <div className='m-0 p-t-15 table-container'>
                                                <div className='row m-p-0'>
                                                    <div className='col s12 m3' style={{border:'solid 1px #cdcdcd'}}>
                                                        <div style={{border:'solid 4px #e8f0fe'}}>
                                                            <label htmlFor="dia" style={{fontSize:10, color:'blue'}}>Pedidos en Sucursal:</label><br/>
                                                            {orden.pedidos_sucursal}
                                                        </div>
                                                    </div>
                                                    <div className='col s12 m6' style={{border:'solid 1px #cdcdcd'}}>
                                                        <div style={{border:'solid 4px #e8f0fe'}}>
                                                            <label htmlFor="dia" style={{fontSize:10, color:'blue'}}>Sucursal:</label><br/>
                                                            {orden.nombre_sucursal}
                                                        </div>
                                                    </div>
                                                    <div className='col s12 m3' style={{border:'solid 1px #cdcdcd'}}>
                                                        <div style={{border:'solid 4px #e8f0fe'}}>
                                                            <label htmlFor="dia" style={{fontSize:10, color:'blue'}}>Total del Corte:</label><br/>
                                                            ${orden.total_sucursal}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                    </div>
                                </>
                            )
                        :
                        <Loader />
                        }
                    </div>
                </div> 
            </div> 
        </div>
    );
};

export default ReporteXDiaSucursal;